import { isStaging } from "@tellescope/utils";
import type { Location } from "react-router-dom";

export const getZendeskSrc = (location: Location) => {
  return `${isStaging() && location.pathname.includes("/tellescope2") ? "/tellescope2" : ""}/zd-icon.png`;
};
